import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { Call, CallsService } from '../calls.service'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'
import { ToastService } from '../toast.service'
import { ActivatedRoute } from '@angular/router'
import { combineLatest } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { SpinnerComponent } from '../spinner/spinner.component'

@Component({
  selector: 'app-call-access-request-approve-page',
  standalone: true,
  imports: [AsyncPipe, TranslatePipe, SpinnerComponent],
  templateUrl: './call-access-request-approve-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './call-access-request-approve-page.component.scss',
})
export class CallAccessRequestApprovePageComponent implements OnInit {
  callsService = inject(CallsService)
  toastService = inject(ToastService)
  dialog = inject(MatDialog)
  translateService = inject(TranslateService)
  route = inject(ActivatedRoute)
  callId = parseInt(this.route.snapshot.params['id'], 10)
  accessRequest$ = this.callsService.getCallAccessRequest(this.callId)
  call$ = this.callsService.getCall(this.callId)
  approveAccessRequestMutation = this.callsService.approveAccessRequest()
  grantedNow = false

  ngOnInit() {
    combineLatest([this.accessRequest$, this.call$]).subscribe(([accessRequestResult, callResult]) => {
      if (callResult.isSuccess && accessRequestResult.isSuccess && !accessRequestResult.data.accessProvided) {
        this.openAccessRequestGrantDialog(callResult.data!)
      }
    })
  }

  async openAccessRequestGrantDialog(call: Call) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant('CALLS.ACCESS_REQUEST.APPROVE_DIALOG_TITLE'),
        description: this.translateService.instant('CALLS.ACCESS_REQUEST.APPROVE_DIALOG_DESCRIPTION', { callName: call.name }),
      },
    })
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.approveAccessRequestMutation.mutateAsync(this.callId)
          this.grantedNow = true
          this.toastService.show('CALLS.ACCESS_REQUEST.SUCCESS')
        } catch (error) {
          this.toastService.show('CALLS.ACCESS_REQUEST.FAILURE')
        }
      }
    })
  }
}
